import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UpCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/UpCircleTwoTone";
import AntdIcon from "../components/AntdIcon";
var UpCircleTwoTone = function UpCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpCircleTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UpCircleTwoTone.displayName = 'UpCircleTwoTone';
}
export default /*#__PURE__*/React.forwardRef(UpCircleTwoTone);